import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    veryLow: {
        minWidth: 100,
        backgroundColor: "#00B71D",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    low: {
        minWidth: 100,
        backgroundColor: "#98BB19",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    medium: {
        minWidth: 100,
        backgroundColor: "#FFEA03",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    high: {
        minWidth: 100,
        backgroundColor: "#FF9000",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    veryHigh: {
        minWidth: 100,
        backgroundColor: "#FF4330",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    }
}));

export {useStyles};